import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsConfig, provideDefaultConfig, UrlModule } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { UserPermissionsGuard } from '../../../../../../guards/user-permissions.guard'
import { SharedModule } from '../../../../../shared/shared.module'
import { DispenserShipmentDetailComponent } from './dispenser-shipment-detail.component'

@NgModule({
  declarations: [DispenserShipmentDetailComponent],
  imports: [RouterModule, UrlModule, SharedModule, SpinnerModule],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        DispenserAgreementShipmentDetailsComponent: {
          component: DispenserShipmentDetailComponent,
          guards: [UserPermissionsGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class DispenserShipmentDetailModule {}
